/**
 * @author        yontaek@zumper.com (Yon Taek Chung)
 * @copyright     Copyright (c) 2021, Zumper
 * @description   UnavailablePrompt
 */

import classNames from 'classnames'
import PropTypes from 'prop-types'
import React from 'react'

import css from './UnavailablePrompt.module.scss'

export const UnavailablePrompt = ({ className }) => {
  return (
    <div className={classNames(css.promptContainer, className)}>
      <span className={css.promptHeader}>Call for info</span>
      <span className={css.promptSubHeader}>This property hasn't listed their availability.</span>
    </div>
  )
}

UnavailablePrompt.propTypes = {
  className: PropTypes.string,
}
